import React, { useEffect, useState } from 'react'

import Link from 'next/link'
import Icon from 'components/atomic/Icon'
import { api, hasPerm, SEGUI } from 'utils'
import { useSelector } from 'react-redux'
import { sendGTMData } from 'utils/gtm.js'
import { ELEMENTOSEGUITO } from 'utils/endpoint'
import Segui from 'components/atomic/Segui'

const CARDS_WITH_IMAGE = [
  'parascolastico',
  'corsoadozionale',
  'numerorivista',
  'rivista',
  'volume',
  'modulo',
  'corsoformazione',
]

const GenericCard = React.memo((props) => {
  const { item, classes = '', horizontal = false } = props

  const { utente } = useSelector((state) => state.utente)

  const [following, setFollowing] = useState(false)

  const isAutore = item.model_class === 'utente'

  const params = { content_type_id: item.model, object_id: item.id || item.object_id }

  const handleGTM = (action) => {
    sendGTMData({
      event: 'GAevent',
      eventID: '15',
      eventCategory: 'interazione_contenuti',
      eventAction: action,
      eventLabel: 'autore',
      moreInfo: item.titolo.toGTMFormat(),
    })
  }

  const handleFollow = async () => {
    if (hasPerm(utente, SEGUI)) {
      handleGTM('segui')
      api.post(ELEMENTOSEGUITO, { params }).then(() => checkFollowing())
    }
  }

  const handleUnfollow = async () => {
    if (hasPerm(utente, SEGUI)) {
      handleGTM('segui')
      api.delete(ELEMENTOSEGUITO, { data: params }).then(() => checkFollowing())
    }
  }

  const checkFollowing = async () => {
    api.get(ELEMENTOSEGUITO, { params }).then((response) => {
      const following = response.data['seguito']
      setFollowing(following)
    })
  }

  useEffect(() => {
    if (isAutore && hasPerm(utente, SEGUI)) setFollowing(item.following)
  }, [item.following])

  const thumb = item.preview_image ? item.preview_image : item.main_image ? item.main_image : null

  const classi = `generic-card ${classes}  ${horizontal ? 'generic-card--horizontal' : ''}`

  const hasToShowImage = CARDS_WITH_IMAGE.includes(item.model_class)

  const style = thumb && hasToShowImage ? { backgroundImage: `url(${thumb})` } : getStyle(item)

  function getStyle(item) {
    if (isAutore) {
      if (thumb) {
        return { backgroundImage: `url(${thumb})` }
      }
    } else if (item.model_class === 'paginafaq') {
      return { background: `#FA4D00` }
    } else if (item.model_class === 'pagina') {
      return { backgroundImage: `url(/images/card/pagina.jpg)`, backgroundSize: 'cover' }
    }

    return {}
  }

  const splitTitle = item.titolo?.split(' ')

  const redazionale = item.redazionale || item.redazionale_index

  const abstract = isAutore ? item.headline || item.headline_index : item.descrizione

  return (
    <article className={classi}>
      {isAutore && hasPerm(utente, SEGUI) ? (
        following ? (
          <Segui onClick={handleUnfollow} horizontal={horizontal} following />
        ) : (
          <Segui onClick={handleFollow} horizontal={horizontal} />
        )
      ) : null}
      <Link legacyBehavior href={item.url}>
        <a className="generic-card__image-box" style={style}>
          {item.model_class === 'paginafaq' && splitTitle.length > 1 && (
            <p className="generic-card__image-box__title">
              {splitTitle[0]}
              <span className="white">{splitTitle[1]}</span>
            </p>
          )}
          {isAutore && !thumb && (
            <img className="generic-card__image-box__icon" src={'/images/svg/user.svg'} />
          )}
        </a>
      </Link>
      <Link legacyBehavior href={item.url}>
        <a className="generic-card__content">
          <p className="generic-card__title">{item.titolo}</p>
          <div className="generic-card__abstract" dangerouslySetInnerHTML={{ __html: abstract }} />
          {isAutore ? (
            <p className="generic-card__icon-box">
              {redazionale ? (
                <span>
                  <Icon id="logosymbol" classes="icon--logosymbol" /> Redazione GiuntiScuola
                </span>
              ) : (
                <Icon id="community" classes="icon--community" />
              )}
            </p>
          ) : null}
        </a>
      </Link>
    </article>
  )
})

export default GenericCard
